import { RootState } from "@/store/store";
import { getUsersMeAccountsSelector } from "@/store/accounts/selectors/getUsersMeAccountsSelector";

export const getUsersMeAccountsErrorStatusSelector = (state: RootState) => {
  return (getUsersMeAccountsSelector(state)?.error as any)?.status;
};
